module.exports = __webpack_public_path__ + "img/calendar-month-outline.9ac59002.svg";